module.exports = __webpack_public_path__ + "img/madera026.561bd77a.jpg";